import { h, Component } from 'preact';
import style from './style';

const flexAlignToClass = {
  'initial': 'align-initial',
  'start': 'align-start',
  'end': 'align-end',
  'center': 'align-center',
  'stretch': 'align-stretch'
}
const justifyContentToClass = {
  'initial': 'justify-initial',
  'start': 'justify-start',
  'end': 'justify-end',
  'center': 'justify-center',
  'around': 'justify-around',
  'between': 'justify-between'
}
const directionToSmClass = {
  'row': 'smRow',
  'column': 'smColumn'
}

const Box = ({
  children,
  direction='row',
  smDirection='',
  color='transparent',
  border='square',
  align='initial',
  justify='initial',
  maxWidth='',
  width='',
  height='',
  paddingY='',
  paddingX='',
  marginTop='',
  marginBottom='',
  marginLeft='',
  marginRight='',
  wrap='nowrap',
  overflow='visible',
  className
}) => {
    const classes = [
      style.box,
      style[direction],
      style[directionToSmClass[smDirection]],
      style[color],
      style[border],
      style[flexAlignToClass[align]],
      style[justifyContentToClass[justify]],
      style[wrap],
      className
    ];

    const styles = {
      maxWidth,
      width,
      paddingTop: paddingY,
      paddingBottom: paddingY,
      paddingLeft: paddingX,
      paddingRight: paddingX,
      marginTop,
      marginLeft,
      marginRight,
      marginBottom,
      height,
      overflow
    }
		return (
			<div class={classes.join(' ')} style={styles}>
        {children}
			</div>
		);
}
export default Box;



// WEBPACK FOOTER //
// ./components/box/Box.js